// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1518":"9cb710f045ca9994","3479":"b042a4def789d52b","7916":"2c132a4509698d7a"}[chunkId] + ".css";
};